<template>
  <div class="features">
    <div class="mainContent">
      <div
        v-for="(item, idx) in imgList"
        :key="idx"
        class="flex-column justify-center"
      >
        <div class="text-center">
          <img :src="item.imgSrc" alt="" style="display: inline-block" />
        </div>
        <div class="title text-center">{{ item.title }}</div>
        <div class="desc text-center">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import productFea1 from "@/assets/imgs/replay/ic_01.png";
import productFea2 from "@/assets/imgs/replay/ic_02.png";
import productFea3 from "@/assets/imgs/replay/ic_03.png";
const imgList = [
  {
    imgSrc: productFea1,
    title: "匠心精神",
    desc: "每个产品细节设计,按钮,都考虑到用户的使用体验",
  },
  {
    imgSrc: productFea2,
    title: "高灵活性",
    desc: "没有您需要的APP？联系我们帮您适配",
  },
  {
    imgSrc: productFea3,
    title: "多人同步",
    desc: "支持一号多人同时使用,数据云同步",
  },
];

onMounted(() => {});
</script>
<style scoped>
.features {
  background-color: #f7f7f7;
}

.mainContent {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6rem 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color:#212529
}

.desc {
  font-size: 14px;
  color:#212529
}

@media (max-width: 768px) {
}
</style>